module.exports = __webpack_public_path__ + "static/img/liberal4.94a45c7.png";


//////////////////
// WEBPACK FOOTER
// ./src.common/assets/role/liberal4.png
// module id = 77
// module chunks = 0